class ProductDetailTabs extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-tab-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
    this.viewMoreLabel = this.dataset.viewMore || 'View more';
    this.viewLessLabel = this.dataset.viewLess || 'View less';

    if (!this.triggers.length || !this.panels.length) {
      return;
    }

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.activate(trigger.dataset.tabTrigger);
      });
    });

    this.panels.forEach((panel) => {
      this.setupPanelTruncation(panel);
    });

    this.resizeObserver = new ResizeObserver(() => {
      this.panels.forEach((panel) => {
        this.updatePanelTruncation(panel);
      });
    });

    this.panels.forEach((panel) => {
      const inner = panel.querySelector('.wt-product__detail-tabs__panel-inner');
      if (inner) {
        this.resizeObserver.observe(inner);
      }
    });
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  setupPanelTruncation(panel) {
    const inner = panel.querySelector('.wt-product__detail-tabs__panel-inner');
    const content = panel.querySelector('.wt-product__detail-tabs__panel-content');

    if (!inner || !content) {
      return;
    }

    let toggle = panel.querySelector('[data-tab-view-more]');

    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'wt-product__detail-tabs__view-more';
      toggle.setAttribute('data-tab-view-more', '');
      toggle.addEventListener('click', () => {
        this.setPanelExpanded(panel, !panel.dataset.expanded);
      });
      inner.appendChild(toggle);
    }

    this.updatePanelTruncation(panel);
  }

  updatePanelTruncation(panel) {
    const content = panel.querySelector('.wt-product__detail-tabs__panel-content');
    const toggle = panel.querySelector('[data-tab-view-more]');

    if (!content || !toggle) {
      return;
    }

    if (panel.dataset.expanded === 'true') {
      content.classList.remove('is-truncated');
      toggle.hidden = false;
      toggle.textContent = this.viewLessLabel;
      toggle.setAttribute('aria-expanded', 'true');
      return;
    }

    content.classList.add('is-truncated');

    if (panel.hasAttribute('hidden')) {
      toggle.hidden = true;
      return;
    }

    const isOverflowing = content.scrollHeight > content.clientHeight + 1;

    if (isOverflowing) {
      toggle.hidden = false;
      toggle.textContent = this.viewMoreLabel;
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      toggle.hidden = true;
      content.classList.remove('is-truncated');
    }
  }

  setPanelExpanded(panel, expanded) {
    panel.dataset.expanded = expanded ? 'true' : 'false';
    this.updatePanelTruncation(panel);
  }

  activate(tabId) {
    this.triggers.forEach((trigger) => {
      const isActive = trigger.dataset.tabTrigger === tabId;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.tabPanel === tabId;
      panel.classList.toggle('is-active', isActive);

      if (isActive) {
        panel.removeAttribute('hidden');
        this.updatePanelTruncation(panel);
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }
}

if (!customElements.get('product-detail-tabs')) {
  customElements.define('product-detail-tabs', ProductDetailTabs);
}
